import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate, Navigate } from 'react-router-dom';
import httpService  from '../../api/httpService';
import AlertModal from '../commonComponents/AlertModal';
import { useAuth } from '../../contexts/AuthContext';

function getStoredUser() {
    try {
      const stored = localStorage.getItem('userDetails');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  }

function OrganizationForm({isEditing}) {

    const { userDetails, isLoading } = useAuth();
    const isIsakosAdmin = userDetails?.admin === true || userDetails?.admin === 1;
    const { orgId } = useParams();
    const navigate = useNavigate();
    const [loading, setIsLoading] = useState(false);
    const[isPageLoading, setIsPageLoading] = useState(false);
    const [organizationDetails, setOrganizationDetails] = useState({
        orgname: '',
        primconname: '',
        primconemail: '',
        primconphone: '',
        secconname: '',
        secconemail: '',
        secconphone: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        // country: '',
        country: 0,
        postalcode: '',
        status: 1
    });
    const [error, setError] = useState({});
    const [insertedId, setInsertedId] = useState(null);
    const [responseError, setResponseError] = useState(null);

    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertError, setAlertError] = useState(false);

    const[countries, setCountries] = useState([]);
    const[isNavigate, setIsNavigate] = useState(false);

// <----- to handle input data in the form ----->
    const handleInputChange = (e) => {
        const { name, value} = e.target;
        if (name === "status") {
            setOrganizationDetails(prevDetails => ({
                ...prevDetails,
                [name]: Number(value)
            }));
        }else {
            setOrganizationDetails(prevDetails => ({
                ...prevDetails,
                [name]: value,
            }));
        }
        if (error[name]) {
            setError((prevErrors) => ({
                ...prevErrors,
                [name]: undefined,
            }));
        }
    };

// <----- fetching details for country list ----->
    const fetchCountry = async() =>{
        const orgId = userDetails?.orgId ?? userDetails?.OrgId ?? null;
        const isAdmin = userDetails?.admin === true || userDetails?.admin === 1;
        const url = !isAdmin && orgId != null
            ? `/Country?orgId=${orgId}`
            : '/Country';

        const result = await httpService.getData(url);
        if(result.isSuccess){ 
            setCountries(result.retObject);
        }     
    } 

    useEffect(() => {
        if (!isIsakosAdmin) return;
        fetchCountry();
    }, [isIsakosAdmin]);

// <----- fetching details for edit page ----->   
    useEffect(() => {
        if (!isIsakosAdmin) return;
        if (isEditing) {
            const fetchData = async () => {
                setIsPageLoading(true);
                try{
                    const result = await httpService.getData(`/Organization/${orgId}`);
                    setOrganizationDetails(result.retObject);            
                }catch(err){
                    setAlertMessage("Error in fetching data!");
                    setAlertError(true);
                    setIsAlertModalOpen(true);
                }finally {
                    setIsPageLoading(false);
                }
            }
            fetchData();
        }else {
            setIsPageLoading(false);
        }
    }, [isEditing, orgId, isIsakosAdmin]);

// <----- to validate the form details ----->
    const validateFormData = () => {
        const errors = {};
        if (!organizationDetails.orgname) errors.orgname = "Registry name is required.";
        if (!organizationDetails.primconemail) errors.primconemail = "Email is required.";
        if (!organizationDetails.primconphone) errors.primconphone = "Phone number is required.";
        if (!organizationDetails.primconname) errors.primconname = "Name is required.";
        if (!organizationDetails.country) errors.country = "Country is required.";
        return errors;
    }

// <----- to handle form detail submission ----->
    const handleFormSubmission = async (e) => {
        e.preventDefault();
        const detailError = validateFormData();
        setError(detailError);
        if (Object.keys(detailError).length > 0) {
            return;     
        }
        try {
            setIsLoading(true);
            const payload = {
                ...organizationDetails,
                addedBy: userDetails?.loginid ?? userDetails?.Loginid ?? getStoredUser()?.loginid ?? getStoredUser()?.Loginid ?? ''
            }
            console.log("Organization", payload);
            //return;
            if (isEditing) {
                const result = await httpService.putData(`/Organization/${orgId}`, payload);
                if(result.isSuccess){
                    //setInsertedId(result.retObject.insertedId ?? null);
                    setIsNavigate(true);
                    setAlertMessage("Registry detail updated successfully!");
                    setAlertError(false);
                    setIsAlertModalOpen(true);
                }else{
                    setResponseError(result.message);
                    setAlertMessage(result.message);
                    setAlertError(true);
                    setIsAlertModalOpen(true);
                }
            }else{
                const result = await httpService.postData('/Organization', payload);
                if(result.isSuccess){
                    //setInsertedId(result.retObject.insertedId ?? null);
                    setIsNavigate(true);
                    setAlertMessage("Registry added successfully !");
                    setAlertError(false);
                    setIsAlertModalOpen(true);
                }else{
                    setResponseError(result.message);
                    setAlertMessage(result.message);
                    setAlertError(true);
                    setIsAlertModalOpen(true);
                }
            }  
        } catch (error) {
            console.error('Failed to post data:', error);
            setAlertMessage("Error occured during detail submission !");
            setAlertError(true)
            setIsAlertModalOpen(true);
        } finally {
            setIsLoading(false);
        }
    }

// <----- to handle alert close functionality ----->
    const handleCloseModal = () => {
        setIsAlertModalOpen(false);
        // if (!isEditing) {
        //     setOrganizationDetails({
        //         orgname: '',
        //         primconname: '',
        //         primconemail: '',
        //         primconphone: '',
        //         secconname: '',
        //         secconemail: '',
        //         secconphone: '',
        //         address1: '',
        //         address2: 'address2',
        //         city: '',
        //         state: '',
        //         //country: '',
        //         country: 0,
        //         postalcode: ''
        //     });
        // }
        if(isNavigate){
            navigate('/organization');
        }
    }

  if (isLoading) {
    return <div></div>;
  }
  if (!isIsakosAdmin) {
    return <Navigate to="/organization" replace />;
  }

  return (
    <div className="app-content p-4">
        <div className="container-fluid mt-2">
            <div className="text-start mb-4">
                <Link to = "/organization" className="back-icon">
                    <i className="fa-solid fa-xl fa-circle-arrow-left"></i>
                </Link>
            </div>
            <div className="card custom-card create-user-card">
                <div className="card-header justify-content-between">
                    <div className="card-title">{isEditing ? "Update Registry" : "Add Registry"}</div>
                </div>
                <div className="card-body">
                    {isPageLoading ? (
                        <div className="d-flex justify-content-center align-items-center loader-container">
                            <button className="btn btn-outline-secondary mt-3" type="button">
                                <span className="spinner-border spinner-border-sm align-middle me-2" role="status"
                                    aria-hidden="true"></span>
                                Loading...
                            </button>
                        </div>                                       
                    ) : (
                        <form>
                            <div className="row mb-4">
                                <div className="col-md-6">
                                    <div className="row">
                                        <label htmlFor="orgname" className="col-sm-4 col-form-label">Registry Name :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className={`form-control ${error.orgname ? 'is-invalid' : ''}`}  name="orgname" id="orgname" value={organizationDetails.orgname} onChange={handleInputChange}/>
                                            {error.orgname && (<div className="invalid-feedback">{error.orgname}</div>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <label htmlFor="status" className="col-sm-4 col-form-label">Status :</label>
                                        <div className="col-sm-6">
                                        <select className="form-select" name="status" value={organizationDetails.status} onChange={handleInputChange}>
                                            <option value="">Select</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <h6 className='col-sm-11 sub-section-heading'>Primary Contact</h6>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="primconname" className="col-sm-4 col-form-label">Name :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className={`form-control ${error.primconname ? 'is-invalid' : ''}`}  name="primconname" id="primconname" value={organizationDetails.primconname} onChange={handleInputChange}/>
                                            {error.primconname && (<div className="invalid-feedback">{error.primconname}</div>)}
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="primconemail" className="col-sm-4 col-form-label">Email :</label>
                                        <div className="col-sm-6">
                                            <input type="email" className={`form-control ${error.primconemail ? 'is-invalid' : ''}`}  name="primconemail" id="primconemail" value={organizationDetails.primconemail} onChange={handleInputChange}/>
                                            {error.primconemail && (<div className="invalid-feedback">{error.primconemail}</div>)}
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="primconphone" className="col-sm-4 col-form-label">Phone No. :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className={`form-control ${error.primconphone ? 'is-invalid' : ''}`}  name="primconphone" id="primconphone" value={organizationDetails.primconphone} onChange={handleInputChange}/>
                                            {error.primconphone && (<div className="invalid-feedback">{error.primconphone}</div>)}
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <h6 className='col-sm-11 sub-section-heading'>ISAKOS Member Contact</h6>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="secconname" className="col-sm-4 col-form-label">Name :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="secconname" id="secconname" value={organizationDetails.secconname} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="secconemail" className="col-sm-4 col-form-label">Email :</label>
                                        <div className="col-sm-6">
                                            <input type="email" className="form-control"  name="secconemail" id="secconemail" value={organizationDetails.secconemail} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="secconphone" className="col-sm-4 col-form-label">Phone No. :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="secconphone" id="secconphone" value={organizationDetails.secconphone} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <h6 className='col-sm-11 sub-section-heading'>Registry Address</h6>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="address1" className="col-sm-4 col-form-label">Address Line 1 :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="address1" id="address1" value={organizationDetails.address1} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="address2" className="col-sm-4 col-form-label">Address Line 2 :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="address2" id="address2" value={organizationDetails.address2} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="city" className="col-sm-4 col-form-label">City :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="city" id="city" value={organizationDetails.city} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="state" className="col-sm-4 col-form-label">State :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="state" id="state" value={organizationDetails.state} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="country" className="col-sm-4 col-form-label">Country :</label>
                                        <div className="col-sm-6">
                                            <select id="country" className={`form-select ${error.country ? 'is-invalid' : ''}`} name="country" value={organizationDetails.country} onChange={handleInputChange} >
                                                <option value="">Select</option>
                                                {countries.map((item, index) => (
                                                    <option key={index} value={item.countryId}>
                                                        {item.countryName}
                                                    </option>
                                                ))}                                                                 
                                            </select>
                                            {error.country && (<div className="invalid-feedback">{error.country}</div>)}
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label htmlFor="postalcode" className="col-sm-4 col-form-label">Postal Code :</label>
                                        <div className="col-sm-6">
                                            <input type="text" className="form-control"  name="postalcode" id="postalcode" value={organizationDetails.postalcode} onChange={handleInputChange}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-2 mt-4 mb-2">
                                    {loading ? (
                                        <div className='save-btn-with-loader'>
                                            <button className="btn blue-btn mt-3 me-2">Save</button>
                                            <div className="spinner-border text-primary mt-3" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ):(
                                        <button className="btn blue-btn mt-3 me-2" type="submit" onClick={handleFormSubmission}>Save</button>
                                    )}
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div> 

        <AlertModal
            isOpen={isAlertModalOpen}
            onClose={() => handleCloseModal()}
            //onClose={() => setIsAlertModalOpen(false)}
            title={alertMessage}
            error={alertError}
        />

    </div>
  )
}

export default OrganizationForm;
